import React, { useEffect } from 'react';
import {
  List,
  Datagrid,
  TextField,
  FunctionField
} from 'react-admin';

function PLGImagenesInicioList(props: any) {
  useEffect(() => {
    document.title = 'Listado de PLG - Gasco';
  }, []);

  return (
    <List {...props}>
      <Datagrid rowClick="edit">
        {/* Campo de Imagen (Portada) */}
        <FunctionField
          label="Portada"
          source="portada"
          render={(record: any) => (
            record.portada ? (
              <img
                src={record.portada.url}
                alt={record.portada.alternativeText || 'Portada PLG'}
                style={{ 
                  width: '150px', 
                  height: '73px', 
                  objectFit: 'cover', 
                  borderRadius: '4px' 
                }}
              />
            ) : <span style={{ color: '#ccc' }}>Sin imagen</span>
          )}
        />

        {/* Campo de Texto (Título) */}
        <TextField source="titulo" label="Título" />
      </Datagrid>
    </List>
  );
}

export default PLGImagenesInicioList;